import { Button, Container } from 'react-bootstrap';

export default function ErrorFallback({ _error, resetErrorBoundary }) {
  const handleRecover = async () => {
    try {
      window.localStorage.removeItem('persist:prevencor-localDB');
      window.sessionStorage.clear();

      if ('caches' in window && window.caches?.keys) {
        const keys = await window.caches.keys();
        await Promise.all(keys.map((key) => window.caches.delete(key)));
      }
    } catch {
      // ignora falha de limpeza de storage
    }

    if (typeof resetErrorBoundary === 'function') {
      resetErrorBoundary();
    }
    window.location.replace('/');
  };

  return (
    <Container fluid>
      <div role="alert" style={{ padding: '2rem', textAlign: 'center' }}>
        <h2 className="text-danger">Algo deu errado!</h2>
        <p style={{ color: '#666', margin: '1rem 0' }}>
          Ocorreu um erro inesperado. Por favor, tente novamente.
        </p>
        <Button variant="danger" onClick={handleRecover}>
          Tentar novamente
        </Button>
      </div>
    </Container>
  );
}
